import styled from 'styled-components'

const VIEWPORT = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
}

export const StickyNavContainer = styled.div`
  width: 100%;
  background: #fff;
  line-height: 24px;
  font-size: 1rem;
  padding: 16px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    height: max-content;
    align-items: center;
    justify-content: space-between;
  }
  @media only screen and (min-width: ${VIEWPORT.md}) {
    justify-content: unset;
  }
`

export const XlNav = styled.div`
  margin: 0 auto;
  width: 100%;
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  @media only screen and (min-width: ${VIEWPORT.xl}) {
    width: 1168px;
  }
`

export const StickyNavInfoContainer = styled.div`
  display: none;
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
  }
  @media only screen and (min-width: ${VIEWPORT.md}) {
    justify-content: space-between;
    width: 100%;
    padding-right: 16px;
  }
  @media only screen and (min-width: ${VIEWPORT.xl}) {
    justify-content: space-between;
    width: 100%;
    padding-right: 16px;
    max-width: 1200px;
  }
`

export const StickyNavInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  .navRibbon {
    height: 40px;
  }
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: none;
  }
  @media only screen and (min-width: ${VIEWPORT.md}) {
    display: flex;
    p {
      display: none;
    }
  }
  @media only screen and (min-width: ${VIEWPORT.lg}) {
    p {
      display: block;
    }
  }
`

export const StickyNavRibbon = styled.div`
  background-color: #613889;
  padding: 5px 16px 0;
  display: inline-block;
  max-width: 100%;
  height: 2.188rem;
  font-weight: 500;
  color: #fff;
  font-size: 1rem;
  line-height: 2rem;
  border-radius: 4px;
  font-family: 'HELVETICANOW400NORMAL';
`

export const NavCallout = styled.div`
  text-align: center;
  margin-left: 16px;
  @media only screen and (max-width: ${VIEWPORT.lg}) {
    display: none;
  }
`

export const ButtonPadding = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 197px;
  div > a > div,
  div > a > div > div {
    padding: 8px 0px !important;
  }
`
